import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../Context/GlobalContext";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import {
  UserRound,
  Clock,
  ChevronsRight,
  Search,
  Plus,
  Trash2,
} from "lucide-react";
import storage from "../Assets/js/Global";

const GuestList = () => {
  const { guestList, translatedLabels, getGuestUserList, deleteGuestUser } =
    useContext(GlobalContext);
  const [searchTerm, setSearchTerm] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [guestToDelete, setGuestToDelete] = useState(null);
  const navigate = useNavigate();
  const screenLabels = translatedLabels?.common;

  const filteredGuests = guestList.filter(
    (guest) =>
      `${guest.guest_name}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
      guest.email.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const handleGuestClick = (guest) => {
    storage.set("scanGuest", true);
    navigate("/guest-scan", { state: { guestData: guest } });
  };

  useEffect(() => {
    getGuestUserList(false);
  }, [getGuestUserList]);

  return (
    <div className="content-part">
      <div className="mb-3 mt-2">
        <div className="">
          <input
            type="text"
            className="form-control w-100"
            placeholder={screenLabels?.search?.label_value || "Search Guest..."}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0 fw-bold">
          {screenLabels?.guest_list?.label_value || "Guest List"} (
          {filteredGuests.length})
        </h5>
        <button
          className="btn btn-primary"
          onClick={() => navigate("/guest-scan")}
        >
          {screenLabels?.add_new?.label_value || "Add New"}
        </button>
      </div>

      <div className="guest-list-container">
        {filteredGuests.length > 0 ? (
          filteredGuests.map((guest, index) => {
            return (
              <div
                key={index}
                className="guest-history-card p-3 mb-3 bg-white shadow-sm border-0"
                onClick={() => handleGuestClick(guest)}
                style={{ borderRadius: "15px" }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div
                    className="d-flex align-items-center gap-3"
                    style={{ width: "85%" }}
                  >
                    <div
                      className="guest-avatar-circle"
                      style={{
                        width: "45px",
                        height: "45px",
                        backgroundColor: "#f3f4f6",
                      }}
                    >
                      <UserRound size={22} className="text-primary" />
                    </div>
                    <div style={{ width: "80%" }}>
                      <h6
                        className="fw-bold m-0 text-dark"
                        style={{ fontSize: "17px" }}
                      >
                        {guest.guest_name}
                      </h6>
                      <div
                        className="text-muted truncate-text"
                        style={{ fontSize: "17px" }}
                      >
                        {guest.email}
                      </div>
                    </div>
                  </div>

                  <div
                    className="d-flex align-items-center justify-content-center text-danger"
                    onClick={(e) => {
                      e.stopPropagation();
                      setGuestToDelete(guest);
                      setShowDeleteModal(true);
                    }}
                    style={{
                      cursor: "pointer",
                      width: "36px",
                      height: "36px",
                      backgroundColor: "#fee2e2",
                      borderRadius: "50%",
                    }}
                  >
                    <Trash2 size={18} />
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                  <span
                    className="text-muted d-flex align-items-center gap-1"
                    style={{ fontSize: "14px" }}
                  >
                    <Clock size={13} className="opacity-50" />{" "}
                    {guest.last_scan_time || "Never scanned"}
                  </span>
                  <div
                    className="d-flex align-items-center gap-1 text-primary fw-semibold"
                    style={{ fontSize: "14px" }}
                  >
                    {screenLabels?.scan?.label_value || "Scan"}{" "}
                    <ChevronsRight size={14} />
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="text-center mt-5 py-5">
            <div className="bg-light rounded-circle d-inline-flex p-3 mb-3">
              <UserRound size={40} className="text-muted opacity-50" />
            </div>
            <p className="text-muted mb-0">
              {screenLabels?.no_guest_found?.label_value ||
                "No results found for your search"}
            </p>
          </div>
        )}
      </div>

      {/* Delete Confirmation Modal */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton className="py-2">
          <Modal.Title className="h5">
            {screenLabels?.delete_guest?.label_value || "Delete Guest"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-4">
          <p className="mb-0 fs-18px">
            {screenLabels?.confirm_delete_guest?.label_value ||
              "Are you sure you want to delete this guest?"}
          </p>
          {guestToDelete && (
            <p className="mt-0 text-primary fw-semibold mb-0">
              {guestToDelete.email}
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-primary fs-15px"
            onClick={() => setShowDeleteModal(false)}
          >
            {screenLabels?.cancel?.label_value || "Cancel"}
          </button>
          <button
            className="btn btn-danger fs-15px"
            onClick={async () => {
              if (guestToDelete && guestToDelete.guest_user_key) {
                const success = await deleteGuestUser(
                  guestToDelete.guest_user_key,
                );
                if (success) {
                  setShowDeleteModal(false);
                  setGuestToDelete(null);
                }
              } else {
                setShowDeleteModal(false);
              }
            }}
          >
            {screenLabels?.delete?.label_value || "Delete"}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default GuestList;
